import { useEffect, useState } from "react";

const Filter = ({ callBack, title , sellTime }) => {
  const[specialDate, setSpecialDate] =useState(sellTime);
useEffect(()=>{
  if(sellTime){
      const interval=setInterval(() => {
        
        let d = new Date(0); 
        d.setUTCSeconds(sellTime);
        
        setSpecialDate((d-Date.now())/1000);
      }, 1000);
      return () => clearInterval(interval);
    }
},[specialDate])
  return (
    <div className={`header-product flex flex-row justify-between  pr-3 w-4/5 mx-auto bg-white rounded-full rounded-b-none text-red-600 text-sm mt-6 ${sellTime?'bg-amber-400':''}`}>
      <p onClick={callBack} className="cursor-pointer header-more pl-3 p-2 ">
        ...بیشتر
      </p>
      <p className="p-2">{title}</p>
    </div>
  );
};

export default Filter;
